import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'


const getDefaultStateForNotifications = () => {
  return {
    notifications: [],
    marks_as_read:0
  }
}

// state
const state = getDefaultStateForNotifications()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_NOTIFICATIONS (state) {
      Object.assign(state, getDefaultStateForNotifications())
    },
    RETRIEVE_ALL_NOTIFICATIONS(state, data){
        state.notifications = data
    },
    MARK_AS_READ(state, data){
        state.marks_as_read = data
    }
}

// actions
const actions = {
    resetState({ commit }, payload) {
      commit("RESET_STATE_FOR_NOTIFICATIONS")
    },
    retrieveNotifications({ commit }, data) {
        return axios.post(apiRoutes['RECEIVE_NOTIFICATIONS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('RETRIEVE_ALL_NOTIFICATIONS', response.data.data)
              } else {
                commit('RETRIEVE_ALL_NOTIFICATIONS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    marKNotificationAsRead({ commit }, data) {
        return axios.post(apiRoutes['RECEIVE_NOTIFICATION_MARK_READ'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('MARK_AS_READ', 1)
              } else {
                commit('MARK_AS_READ', 0)
              }
            })
            .catch(error => {
              if (error.response) {
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
}

export {
    state,
    getters,
    actions,
    mutations
}
